import { render, staticRenderFns } from "./solicitud-material-buscar-productos.vue?vue&type=template&id=44285608&scoped=true"
import script from "./solicitud-material-buscar-productos.vue?vue&type=script&lang=js"
export * from "./solicitud-material-buscar-productos.vue?vue&type=script&lang=js"
import style0 from "./solicitud-material-buscar-productos.vue?vue&type=style&index=0&id=44285608&prod&scoped=true&lang=css"
import style1 from "./solicitud-material-buscar-productos.vue?vue&type=style&index=1&id=44285608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44285608",
  null
  
)

export default component.exports